import { useState } from 'react';

import { Button, CloseButton } from '../../shared/ui';

interface MicrophoneUnheardBannerProps {
  onRestart: () => Promise<unknown>;
}

export function MicrophoneUnheardBanner({ onRestart }: MicrophoneUnheardBannerProps) {
  const [isDismissed, setIsDismissed] = useState(false);
  const [isRestarting, setIsRestarting] = useState(false);

  if (isDismissed) return null;

  const onRestartClick = async () => {
    setIsRestarting(true);

    try {
      await onRestart();
    } finally {
      setIsRestarting(false);
    }
  };

  return (
    <div
      role="alert"
      className="fixed top-4 left-1/2 z-[70] flex w-[calc(100%-32px)] max-w-[440px] -translate-x-1/2 items-start gap-3 rounded-control border border-primary bg-white px-4 py-3 shadow-raised"
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <span className="text-body-l-strong text-ink">Похоже, вас не слышно</span>
        <span className="text-ui text-ink-muted">
          Микрофон включён, но звук от него не поступает. Перезапустите микрофон — выходить из встречи не нужно.
        </span>
        <Button type="button" size="sm" className="self-start" loading={isRestarting} onClick={onRestartClick}>
          Перезапустить микрофон
        </Button>
      </div>
      <CloseButton size="sm" onClick={() => setIsDismissed(true)} />
    </div>
  );
}
